
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.649 12H11.882a3.117 3.117 0 00-3.116 3.117v9.7a3.117 3.117 0 003.116 3.117H27.65a3.118 3.118 0 003.117-3.117v-9.7A3.118 3.118 0 0027.649 12zm-5.28 8.666L17.86 22.92a.782.782 0 01-1.13-.7v-4.505c0-.58.611-.957 1.13-.7l4.507 2.253a.783.783 0 010 1.4z","fill":"#fff"}}),_c('path',{attrs:{"d":"M31.439 40H8.56C3.841 40 0 36.159 0 31.439V8.56C0 3.841 3.84 0 8.561 0H31.44C36.159 0 40 3.841 40 8.561V31.44C40 36.159 36.159 40 31.439 40zM8.56 1.557A7.012 7.012 0 001.557 8.56V31.44a7.012 7.012 0 007.004 7.004H31.44a7.012 7.012 0 007.004-7.004V8.56a7.012 7.012 0 00-7.004-7.004H8.56z","fill":"#fff"}})])
          )
        }
      }
    